import React from 'react'

import { useModal } from '@/contexts/ModalContext'

import { onUncaughtError } from '@/services/userAlerts'
import { ENDPOINTS, sendPostRequest } from '@/services/api'

import { useTranslation } from 'react-i18next'
import { i18n } from '@/translate/i18n'
import Swal from 'sweetalert2'

import * as S from './styles'

export interface MoveCollectionDropModalConfig {
  collectionId: string
  collectionName: string
  folderId: string
  folderName: string
  setAction: (action: boolean) => void
  action: boolean
  setLoading: (loading: boolean) => void
}

export interface MoveCollectionDropModalProps {
  config: MoveCollectionDropModalConfig
}

const MoveCollectionDropModal = ({ config }: MoveCollectionDropModalProps) => {
  const { closeModal } = useModal()

  const { t } = useTranslation()

  const onSuccess = () => {
    config.setAction(!config.action)
    Swal.fire({
      icon: 'success',
      title: i18n.t('swal.success'),
      html: i18n.t('messages.collectionMoved')
    })
  }

  const moveCollection = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    config.setLoading(true)
    closeModal()

    const body = {
      id: config.collectionId,
      folder_id: config.folderId
    }

    try {
      await sendPostRequest(ENDPOINTS.move_collection, body)
      onSuccess()
    } catch (error) {
      const msg = error.data || error
      console.log(msg)
      onUncaughtError()
    } finally {
      config.setLoading(false)
    }
  }

  return (
    config && (
      <S.MoveCollectionContainer>
        <S.MoveCollectionTitle>
          <p>
            {t('buttons.move')} {config.collectionName} {t('messages.to')}{' '}
            {config.folderName}?
          </p>
          <button
            id="btn_closemodal_move_drop"
            type="button"
            onClick={closeModal}
          >
            <span className="material-icons">close</span>
          </button>
        </S.MoveCollectionTitle>

        <S.MoveCollectionContent>
          <div className="buttons">
            <button
              type="button"
              onClick={closeModal}
              id="btn_cancel_move_drop"
            >
              {t('buttons.cancel')}
            </button>
            <button type="submit" onClick={moveCollection} id="btn_move_drop">
              {t('buttons.move')}
            </button>
          </div>
        </S.MoveCollectionContent>
      </S.MoveCollectionContainer>
    )
  )
}

export default MoveCollectionDropModal
